import { DATASET, MIDDAY, NOW } from '../../cms/constants';
import client from '../../cms/client';

const getShouldSkipClientSideRequest = (): boolean => {
  const { useLiveFiltering, asAtDate, asAtTime, dataset } = client;
  return !useLiveFiltering || (asAtDate === NOW && asAtTime === MIDDAY && dataset === DATASET.PRODUCTION);
};

export default getShouldSkipClientSideRequest;
